<script>
import axios from 'axios';
import sentry from '@/analytics/sentry';

export default {
    name: 'FetchTemplatesByPage',

    props: {
        query: {
            type: Object,
            required: true,
        },

        pageSize: {
            type: Number,
            default: 25,
        },

        useEmailSubjectAsName: {
            type: Boolean,
            default: false,
        },

        variables: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            nextPageNumber: null,
            results: [],
            isLoading: false,
            isFullyLoaded: false,
            error: null,
        };
    },

    created() {
        this.fetchPage();
    },

    watch: {
        variables() {
            this.reload();
        },
    },

    methods: {
        async fetchPage() {
            this.isLoading = true;

            try {
                const res = await axios.request({
                    url: this.query.url,
                    method: this.query.method,
                    params: {
                        page: this.nextPageNumber,
                        ...this.variables,
                    },
                    data: this.query.data,
                });

                const {
                    nextPage,
                    globalTemplates,
                    templates,
                    broadcasts,
                } = res.data;

                const results = (globalTemplates || templates || broadcasts || [])?.map((template, index) => (
                    template.emailTemplate
                        ? ({
                            id: template.emailTemplate.externalTemplateId,
                            name: (this.useEmailSubjectAsName ? template.emailTemplate.subject : template.emailTemplate.title)
                                        || this.$t('email.broadcast.unlayer.template.untitled'),
                            html: template.emailTemplate.htmlBody,
                            key: `${template.emailTemplate.externalTemplateId}-${(1 + Math.random()) * 0x10000}`,
                            broadcastId: Array.isArray(broadcasts) ? broadcasts[index].id : undefined,
                        }) : ({
                            id: template.id,
                            name: template.title,
                            html: template.html,
                            previewUrl: template.thumbnailUrl,
                        })
                ));

                this.results.push(...results);
                this.nextPageNumber = nextPage;
                this.isFullyLoaded = !nextPage;
            } catch (error) {
                sentry.captureException(error);
                this.error = error;
                this.$emit('error', error);
            }

            this.isLoading = false;
        },

        async reload() {
            this.nextPageNumber = null;
            this.results = [];
            this.isLoading = false;
            this.isFullyLoaded = false;
            this.error = null;

            try {
                await this.fetchPage();
            } catch (error) {
                sentry.captureException(error);
                this.error = error;
                this.$emit('error', error);
            }
        },
    },

    render() {
        const {
            pageSize,
            nextPageNumber,
            results,
            isLoading,
            isFullyLoaded,
            error,
            fetchPage,
            reload,
        } = this;

        return this.$scopedSlots.default({
            pageSize,
            nextPageNumber,
            results,
            isLoading,
            isFullyLoaded,
            error,
            fetchPage,
            reload,
        });
    },
};
</script>
